const moment = require('moment-timezone')

/**
 * is same time frame as today?
 * yes: showing the time, (ie: 3:00pm)
 * no: show date (without time info)
 */

const formatTime = (timestamp, isLong = false) => {
  const now = moment()
  const cmp = moment(timestamp) // object to compare to today
  if (isLong) {
    return cmp.format('MMM D, h:mm a')
  }
  return cmp.isSame(now, 'day') ?
    cmp.format('h:mm a') :
    cmp.format('MMM Do')
}

const sameMessagesArray = (prevMessages, currentMessages) => {
  const prevStatuses = prevMessages.map((msg) => msg.status).sort()
  const currentStatuses = currentMessages.map((msg) => msg.status).sort()
  if (
    !prevStatuses ||
    !currentStatuses ||
    prevStatuses.length !== currentStatuses.length
  ) return false
  for (let i = 0; i < prevStatuses.length; i++) {
    if (prevStatuses[i] !== currentStatuses[i]) return false
  }
  return true
}

const autoChooseActiveConvo = (convoId, isBlastMsg) => !!convoId || !isBlastMsg

module.exports = { formatTime, autoChooseActiveConvo, sameMessagesArray }



// WEBPACK FOOTER //
// ./src/components/Messages/utils.js